import React from 'react';
import { observer } from 'mobx-react';
import { getOption } from 'core/form/components/modalSelect/selectHelpers';
import { Flex, Tag } from 'core/components';
import KentikLogo from 'app/components/KentikLogo';

const RunbookValueTagRenderer = (props) => {
  const { onUnselectBuilder, options, values, runbooks, onTagClick } = props;

  // If runbooks array is passed directly (for read-only display), use that
  if (runbooks) {
    return runbooks.map((runbook, idx) => {
      const { id, name, isPreset } = runbook;
      const clickable = !!onTagClick;
      return (
        <Tag
          key={id || idx}
          minimal
          interactive={clickable}
          pl={isPreset ? '6px' : undefined}
          onClick={clickable ? () => onTagClick(runbook) : undefined}
        >
          <Flex alignItems="center" gap="4px">
            {isPreset && <KentikLogo onlyMark alt="Kentik" style={{ minWidth: 14, maxWidth: 14 }} />}
            {name}
          </Flex>
        </Tag>
      );
    });
  }

  // Otherwise use options for Select component (editable context)
  if (!options) {
    return null;
  }

  return values.map((val) => {
    const valueOption = getOption(options, val);
    if (!valueOption) {
      return null;
    }

    const { label, isPreset } = valueOption;
    const onRemove = onUnselectBuilder(valueOption.value || valueOption);

    return (
      <Tag key={valueOption.key || val} minimal round onRemove={onRemove} pl={isPreset ? '6px' : undefined}>
        <Flex alignItems="center" gap="4px">
          {isPreset && <KentikLogo onlyMark alt="Kentik" style={{ minWidth: 14, maxWidth: 14 }} />}
          {label}
        </Flex>
      </Tag>
    );
  });
};

export default observer(RunbookValueTagRenderer);
